@if (name()) {
  @if (hasImage()) {
    <div [routerLink]="careproviderRouterLink()"
         class="item-image w-full aspect-[3/1] relative rounded cursor-pointer">
      @if (isPriorityImage()) {
        <img [alt]="name()" [ngSrc]="imageUrl()"
             [placeholderConfig]="{blur: false}"
             class="h-full w-full cursor-pointer object-cover object-[50%_30%] rounded-lg border border-grey-8"
             [attr.fetchpriority]="fetchPriority()"
             [priority]="true"
             fill="true"
             placeholder="data:image/png;base64,UklGRloAAABXRUJQVlA4IE4AAABQBwCdASqgAGQAP3G42GU0ryunIIgCkC4JaQAW30AntsReIBVVREKt3CqqIhceIVVREakRCqqJE4iIVVSXVURCqqAAAP7tqAAAAAAAAAA=">
      } @else {
        <img [alt]="name()" [ngSrc]="imageUrl()" [placeholderConfig]="{blur: false}"
             class="h-full w-full cursor-pointer object-cover object-[50%_30%] rounded-lg border border-grey-8"
             [attr.fetchpriority]="fetchPriority()"
             [loading]="loadingPriority()"
             fill="true"
             placeholder="data:image/png;base64,UklGRloAAABXRUJQVlA4IE4AAABQBwCdASqgAGQAP3G42GU0ryunIIgCkC4JaQAW30AntsReIBVVREKt3CqqIhceIVVREakRCqqJE4iIVVSXVURCqqAAAP7tqAAAAAAAAAA=">
      }

      @if (logoUrl() && logoUrl() !== '') {
        <div
          class="w-16 h-16 bg-white rounded-full absolute border border-grey-8 justify-center items-center -top-2 -left-2">
          @if (isPriorityImage()) {
            <img
              [alt]="name() + ' logo'"
              [ngSrc]="logoUrl()"
              [placeholderConfig]="{blur: false}"
              class="object-contain rounded-full"
              [attr.fetchpriority]="fetchPriority()"
              [priority]="true"
              fill="true"
              placeholder="data:image/png;base64,UklGRloAAABXRUJQVlA4IE4AAABQBwCdASqgAGQAP3G42GU0ryunIIgCkC4JaQAW30AntsReIBVVREKt3CqqIhceIVVREakRCqqJE4iIVVSXVURCqqAAAP7tqAAAAAAAAAA=">
          } @else {
            <img
              [alt]="name() + ' logo'"
              [ngSrc]="logoUrl()"
              [placeholderConfig]="{blur: false}"
              class="object-contain rounded-full"
              [attr.fetchpriority]="fetchPriority()"
              [loading]="loadingPriority()"
              fill="true"
              placeholder="data:image/png;base64,UklGRloAAABXRUJQVlA4IE4AAABQBwCdASqgAGQAP3G42GU0ryunIIgCkC4JaQAW30AntsReIBVVREKt3CqqIhceIVVREakRCqqJE4iIVVSXVURCqqAAAP7tqAAAAAAAAAA=">
          }
        </div>
      }

      <div class="absolute bottom-2 right-2 flex justify-end items-center gap-1">
        @if (mainCaregiverUnitType()) {
          <div
            [matTooltipClass]="'varden-tooltip'"
            [matTooltipPosition]="'below'"
            [matTooltip]="mainCaregiverUnitType().name"
            class="flex rounded-full bg-grey-10 justify-center items-center w-fit h-7 px-3 py-2 text-sm text-grey-0 max-w-52"
          >
            <span class="truncate max-w-full">{{ mainCaregiverUnitType().name }}</span>
          </div>
        }

        @if (rating()) {
          <div [matTooltipClass]="'varden-tooltip'"
               [matTooltipPosition]="'below'"
               [matTooltip]="ratingTooltip()"
               class="flex rounded-full gap-1 bg-grey-10 justify-center items-center w-fit h-7 px-3 py-2 text-sm text-grey-0">
            <app-ui-icon
              [name]="'star_filled'"
              [size]="'sm'"
              color="var(--apricot-3)"
            ></app-ui-icon>
            <span>{{ rating() | round: 1 }}</span>
          </div>
        }
      </div>
    </div>
  }

  @if (isHsa() && !hasImage()) {
    <div [routerLink]="careproviderRouterLink()"
         class="item-image w-full aspect-[3/1] relative rounded cursor-pointer bg-apricot-9 flex justify-center items-center">
      <app-segment-icon [imageSize]="90"
                        [isPriority]="isPriorityImage()"
                        [segment]="mainSegment()"></app-segment-icon>
    </div>
  }
}
